import { FC, PropsWithChildren } from 'react';
import { DetailedSourceLanguageResponse } from 'src/types/languagesDomain';
import { LanguagePairContext } from './context';

export type LanguagePairProviderProps = {
  languagePair: DetailedSourceLanguageResponse;
};

export const LanguagePairProvider: FC<PropsWithChildren<LanguagePairProviderProps>> = ({
  children,
  languagePair,
}) => {
  return (
    <LanguagePairContext.Provider value={languagePair}>{children}</LanguagePairContext.Provider>
  );
};
